import { render, staticRenderFns } from "./ThonFooter.vue?vue&type=template&id=17665f97"
import script from "./ThonFooter.vue?vue&type=script&lang=js"
export * from "./ThonFooter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports